<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <p>La promoción se ha creado correctamente</p>
    <button class="btn btn-primary generalPrimaryButton float-right" data-dismiss="modal"
      @click="close()">Cerrar</button>
  </Modal>
</template>

<script>
import Modal from '../../../Shared/Modal.vue';

export default {
  name: 'ModalFinal',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
  ],
  components: {
    Modal
  },
  data() {
    return {
      classes: this.class
    }
  },
  methods: {
    close() {
      this.$router.push({ name: 'promociones' })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
